import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import type { ProviderScope } from '~/types/Provider';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import Panel from '~/components/ui/Panel';
import { Link } from '~/components/ui/Link';


type ProviderScopesPanelProps = {
  companyName: string;
  scopes: ProviderScope[];
  hasPartnership?: boolean;
};

const ProviderScopesPanel: React.FC<ProviderScopesPanelProps> = ({ companyName, scopes }) => {
  if (!scopes || scopes.length === 0) {
    return null;
  }
  
  return (
    <Panel>
      <h3 className="panel-title--primary">Producten</h3>
      <div>
        <h4 className="panel-title--secondary">{companyName} biedt de volgende producten aan:</h4>

        <section>
          <header className="hidden md:block bg-blue-600 campaign-accent-background leading-loose text-white px-4 py-1 font-semibold">
            Product
          </header>
          <div className="grid gap-4 md:gap-0 md:border md:panel-separator-border-color" role="list">
            {scopes?.map(({ name, slug }) => (
              <div key={slug} className="p-3 md:px-4 flex flex-col gap-4 md:flex-row items-center justify-between panel-separator-border-color rounded-lg border md:rounded-none md:border-t-0 md:border-x-0 md:last:border-0">
                <div>
                  <a href={`/${slug}`} className="font-semibold mr-2">{name}</a>
                </div>
                <Link
                  variant="primary"
                  className="w-full md:w-auto font-medium"
                  href={`/${slug}`}
                  size="small"
                >
                  Zoek een adviseur
                  <FontAwesomeIcon icon={faChevronRight as IconProp} />
                </Link>
              </div>
            ))}
          </div>
        </section>
      </div>
    </Panel>
  );
};

export default ProviderScopesPanel;